//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import banner from '@/assets/fangyi/banner.png'
export default {
  name: 'fangyiruleIndex',
  components: {
  },
  data () {
    return {
      banner: banner
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
  },
  created () {
  }
}
